import { ArrowLeftPagination } from '@assets/svgs/ArrowLeftPagination'
import { ArrowRightPagination } from '@assets/svgs/ArrowRightPagination'

import type { SimulationsPaginationProps } from './types'

import * as S from './styles'

export const SimulationsPagination = ({ currentPage, totalPages, onPageChange }: SimulationsPaginationProps) => {
  if (totalPages <= 1) {
    return (
      <S.Container>
        <S.BulletsContainer>
          <S.Bullet active />
        </S.BulletsContainer>
      </S.Container>
    )
  }

  return (
    <S.Container>
      <S.ArrowButton disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} title="Página anterior">
        <ArrowLeftPagination />
      </S.ArrowButton>
      <S.BulletsContainer>
        {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
          <S.Bullet key={page} active={page === currentPage} onClick={() => onPageChange(page)} title={`Página ${page}`} />
        ))}
      </S.BulletsContainer>
      <S.ArrowButton disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} title="Próxima página">
        <ArrowRightPagination />
      </S.ArrowButton>
    </S.Container>
  )
}
